import logoImage from "public/images/knicks/knicks-mock-logo.png";
import { routes } from "src/shared/routes";
import { TTeamConfig } from "src/shared/types/teamConfig.types";

export const knicks: TTeamConfig = {
  TEAM_SCHEMA: "knicks",
  CLIENT_ID: "",
  TEAM_FULL_NAME: "MSG Knicks",
  BROWSER_TITLE: "MSG Knicks",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#F58426",
    COLORS_SECONDARY: "#00438C",
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
  },

  IMAGES: {
    LOGO_URL: logoImage.src,
  },

  LANGUAGES: {
    FAQS: [],
  },
};
